// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35ldZ","toggleWrap":"styles_toggleWrap__18mLH","content":"styles_content__jlDEh","selectAreaCode":"styles_selectAreaCode__2jvBZ"};